import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import api from '@/admin/lib/api'

/**
 * WPS-157 §13: tenant-level documentation-reminder cadence, kept separately for
 * claims and transfers. A `null` value means "not set" - the scheduled sweep
 * falls back to the tenant trigger schedule for that field.
 */
export interface ReminderCadence {
  interval_days: number | null
  max_reminders: number | null
}

export interface ReminderSettings {
  claims: ReminderCadence
  transfers: ReminderCadence
}

export function useReminderSettings() {
  return useQuery<ReminderSettings>({
    queryKey: ['reminder-settings'],
    queryFn: () =>
      api.get('/organisations/reminder-settings/').then((r) => r.data),
  })
}

export function useUpdateReminderSettings() {
  const qc = useQueryClient()
  return useMutation<ReminderSettings, Error, Partial<ReminderSettings>>({
    mutationFn: (data) =>
      api.patch('/organisations/reminder-settings/', data).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['reminder-settings'] })
    },
  })
}
